/* eslint-disable @typescript-eslint/no-explicit-any */
import { IComplaint } from '../types/complain';
import { ILogger } from '@cian/error-log-component';

export const proccessComplaints = (complaintsRaw: IComplaint[], offerIsByHomeowner?: boolean) => {
  const skipIds = ['89_1089'];

  let complaints = complaintsRaw;

  if (!offerIsByHomeowner) {
    complaints = complaints.filter(item => skipIds.indexOf(item.id) < 0);
  }

  return complaints;
};

export const proccessGetComplaintsError = (
  // tslint:disable-next-line: no-any
  reason: any,
  logger: ILogger,
) => {
  logger.error(reason);

  return 'Не удалось получить информацию о предложении. Проверьте своё интернет соединение и попробуйте еще раз.';
};

export const proccessSendComplaintsError = (
  // tslint:disable-next-line: no-any
  reason: any,
  logger: ILogger,
) => {
  logger.error(reason);

  return 'Не удалось отправить жалобу. Проверьте своё интернет соединение и попробуйте еще раз.';
};

export const proccessSendFeedbacksError = (
  // tslint:disable-next-line: no-any
  reason: any,
  logger: ILogger,
) => {
  logger.error(reason);
};

export const checkCategoriesIds = (offerCategoriesIds: number[], offerId: number, logger: ILogger) => {
  if (!offerCategoriesIds || offerCategoriesIds.length < 1) {
    logger.error(`Failed to get complaints for offer ${offerId}: offer not categorized`);

    return 'Произошла внутренняя ошибка сервиса. Информация об ошибке была направлена нашим разработчикам.';
  }

  return '';
};
